var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Flatfinder',_vm._g(_vm._b({staticClass:"project-mutate-flatfinders"},'Flatfinder',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }